import { PropsWithChildren, createContext, useContext, useEffect, useState } from "react";

import { api } from "../utils";
import { IError } from "../models/ReportPageModels";
import { MaskImageModel } from "../components/Admin/pages/Mobile/EditMaskStructure/EditMaskStructure";

interface AllMaskImagesRequest {
    data: AllMaskImagesData;
    error: IError;
}
interface AllMaskImagesData {
    masks: MaskImageModel[];
}

type MaskImagesType = {
    allMaskImages: MaskImageModel[];
}

export const MaskImagesContext = createContext<MaskImagesType | undefined>(undefined);

export const MaskImagesProvider = ({ children }: PropsWithChildren<{}>) => {
    const [allMaskImages, setAllMaskImages] = useState<MaskImageModel[]>([])

    useEffect(() => {
        GetMaskStructure();
    }, [])

    const GetMaskStructure = async () => {
        try {
            const response: AllMaskImagesRequest = await api.get("api/Admin/GetMaskStructure", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error === null) {
                setAllMaskImages(response.data.masks)
            }
        }
        catch (_err) {

        }
    }

    return (
        <MaskImagesContext.Provider value={{ allMaskImages }}>
            {children}
        </MaskImagesContext.Provider>
    );
}

export const useMaskImagesContext = () => {
    const context = useContext(MaskImagesContext);

    if (!context) {
        throw new Error('useThemeContext must be used inside the ThemeProvider');
    }

    return context;
};